/* eslint-disable no-case-declarations */
import { getLastCategoryLevel } from '@/helpers/getLastCategoryLevel'

const initCatalog = async function ({ commit, rootState }, route) {
    const type = route.matched[0].name
    const slug = getSlug.call(this, route, type)

    // The key of the api that we want to time.
    const timingKey = `${type}-api`

    try {
        let data = {}

        // Based on the slug, we know if we should be hitting an api to get data or not.
        // the search page does not hit an api...
        if (slug) {
            const timeTravel = route.query.timeTravel ? `?timeTravel=${route.query.timeTravel}` : ''

            // Set the api endpoint to catalog if the route is specials or new-products, otherwise set to type
            const endpoint = type === 'specials' || type === 'new-products' ? 'catalog' : type

            this.$timing.start(timingKey)

            // Get data from api
            data = await this.$axios.$get(
                `${this.$config.platform.apis[endpoint]}${slug}${timeTravel}`
                // {
                //     headers: {
                //         'x-perm-id': rootState.permId,
                //     },
                // }
            )

            this.$timing.end(timingKey)
        }
        // Parse data
        const formattedData = processData.call(this, data, type, route)

        commit('setData', formattedData)
    } catch (error) {
        commit('setData', null)
    } finally {
        await this.$storyblok.getPreviewStory()
    }
}

export default {
    initCatalog,
}

function getSlug(route, type) {
    switch (type) {
        case 'category':
            const arr = []

            for (let i = 0; i <= getLastCategoryLevel(route); i++) arr.push(route.params[`lvl${i}`])

            // If we are in preview mode, we don't want to hit the cat endpoint with a customFacet because if the page is not published, it will 404.
            if (route.params.facetSlug && !this.$storyblok.isPreview)
                arr.push(`?customFacet=${route.params.facetSlug}`)
            return arr.join('/')

        case 'brand':
            return route.params.brandSlug

        case 'mmy':
            const mmy = [route.params.makeSlug]
            if (route.params.modelSlug) mmy.push(route.params.modelSlug)
            if (route.params.year) mmy.push(route.params.year)
            return mmy.join('/')

        case 'new-products':
        case 'specials':
            // We can just return the type as the slug for specials and new-products
            return type

        default:
            // If its not one of these then we need to return nothing
            return null
    }
}

function processData(data, type, route) {
    const obj = data
    const lastCategoryLevelInUrl = getLastCategoryLevel(route)

    obj.type = type

    obj.category = {
        facetLevel: lastCategoryLevelInUrl !== undefined ? lastCategoryLevelInUrl + 1 : 0,
        showAsFacet: false,
    }

    obj.showSameDayShippingFacet = this.$sitewideData.config.sameDayShippingEnabled
    obj.title = data.name // used in queries too!?
    obj.facets = data.facets || []

    // Check if the sameDayShipping Facet on the current page
    const sameDayShippingFacetIndex = obj.facets.findIndex(
        ({ facet }) => facet === 'sameDayShipping'
    )
    if (sameDayShippingFacetIndex > -1) {
        // sameDayShipping is a special facet where we only want to show it if its enabled and show it in our special facet component
        // so we need to make sure that we don't ever show it as a standard facet, even if the api tells us to which is why
        // we always need to splice it from the facets array if it exists.
        obj.facets.splice(sameDayShippingFacetIndex, 1)
    }

    if (type === 'brand') {
        if (this.$sitewideData.config.useSecondLevel) obj.category.facetLevel = 1
    }

    if (type === 'mmy') {
        obj.title = 'Parts &amp; Accessories'

        if (this.$sitewideData.config.useSecondLevel) obj.category.facetLevel = 1
    }

    if (type === 'specials') {
        obj.title = 'Deals'

        obj.category.showAsFacet = true

        const levelText = this.$sitewideData.config.useSecondLevel
            ? 'categories.lvl1.text'
            : 'categories.lvl0.text'

        obj.facets.push({ facet: levelText, text: 'Category' })
    }

    if (type === 'new-products') {
        obj.title = 'New Products'

        obj.category.showAsFacet = true

        const levelText = this.$sitewideData.config.useSecondLevel
            ? 'categories.lvl1.text'
            : 'categories.lvl0.text'

        obj.facets.push({ facet: levelText, text: 'Category' })
    }

    if (type === 'search') {
        const query = route.query.q.replace(/[^\da-z-+ ]+/gi, '')
        obj.title = `Search results for "${query || ''}"`

        obj.category.showAsFacet = true

        const levelText = this.$sitewideData.config.useSecondLevel
            ? 'categories.lvl1.text'
            : 'categories.lvl0.text'

        obj.facets = [
            { facet: levelText, text: 'Category' }, // TODO: We'll have to get the level from the api soon (along with banners etc..) RT will show level1, others level 0
            { facet: 'priceRange', text: 'Price Range' },
            { facet: 'brand', text: 'Brand' },
        ]
    }

    return obj
}
